export const defaultState = () => ({
  offerId: null,
  errors: {},
  formData: {
    name: '',
    validFrom: '',
    validTo: '',
    createdAt: '',
    isCountdownEnabled: false,
    affiliate: null,
    services: [],
    bottomBannerId: null,
    bottomBanner: null,
    topBannerId: null,
    topBanner: null,
    slug: '',
    manager: '',
  },
});

export default () => ({
  isShown: false,
  privateOffersLoading: false,
  time: '',
  ...defaultState(),
});
